// assets
import {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  BankOutlined,
  InsertRowBelowOutlined,
  FormOutlined,
  CarOutlined,
  BarcodeOutlined,
  ClusterOutlined,
  GoldOutlined
} from '@ant-design/icons';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  BankOutlined,
  InsertRowBelowOutlined,
  FormOutlined,
  CarOutlined,
  BarcodeOutlined,
  ClusterOutlined,
  GoldOutlined
};

// ==============================|| MENU ITEMS - management ||============================== //

const management = {
  id: 'management',
  title: 'Management',
  icon: icons.BuildOutlined,
  type: 'group',
  children: [
    {
      id: 'logs',
      title: '로그',
      url: '/management/logs',
      type: 'item',
      icon: icons.FileTextOutlined,
      breadcrumbs: false
    },
    {
      id: 'users',
      title: '사용자',
      url: '/management/users',
      type: 'item',
      icon: icons.UserOutlined,
      breadcrumbs: false
    }
  ]
};

export default management;
